import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import BreakpointContext from "../../contexts/breakpointContext";
import useUserInfo from "../../hooks/queryResults/useUserInfo";
import useCurrentUser from "../../hooks/useCurrentUser";
import Util from "../../util/util";
import LoginForm from "../auth/LoginForm";

const Home = () => {
  const breakpoints = useContext(BreakpointContext);
  const currentUser = useCurrentUser();
  const { userInfo } = useUserInfo();
  const [url, setUrl] = useState(null);

  let loginForm = null;
  if (!currentUser.obj.isLoggedIn) {
    loginForm = <LoginForm />;
  }

  useEffect(() => {
    if (userInfo && userInfo.data) {
      if (userInfo.data.user.selectedLeagueSeason) {
        const leagueSeason =
          userInfo.data.leagueSeasons[userInfo.data.user.selectedLeagueSeason];
        if (leagueSeason) {
          const league = userInfo.data.leagues[leagueSeason.league];
          if (league) {
            const slugOrId = !!league.slug ? league.slug : league.id;
            const week = Util.getCurrentWeek();
            const weekUrl = Util.weekToUrl(week);
            const url = `/${slugOrId}/${leagueSeason.season}/${weekUrl}`;
            setUrl(url);
          }
        }
      }
    }
  }, [userInfo]);

  const message = (
    <>
      <h1>Home - East-West Football League</h1>
      <p>
        Welcome to the new site for the East-West Football League! It's still a
        work in progress, but I promise it is going to be way better than our
        old one. You can sign in with your same credentials as before. If you've
        forgotten your username and/or password, simply email me and I'll get
        you sorted in no time. Thanks, and good luck for the upcoming season!
      </p>
      <h3>Matthew Gadbois</h3>
    </>
  );

  let flexFlow = "column nowrap";
  let margin = "0 0 2rem 0";
  let alignItems = "center";
  if (breakpoints.lg) {
    flexFlow = "row nowrap";
    margin = "0 2rem 0 0";
    alignItems = "flex-start";
  }

  return (
    <div style={{ display: "flex", flexFlow, alignItems }}>
      {!!url ? <Redirect to={url} /> : null}
      <div style={{ margin, maxWidth: "60%" }}>{message}</div>
      <div>{loginForm}</div>
    </div>
  );
};

export default Home;
